
    import { Component, Vue } from 'vue-property-decorator';
    
    @Component
    export default class PossessionCompanionFaqDropdown extends Vue {
        showAssistance = false;
    }
